import React from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { ReactSession } from "../../../lib/secure_reactsession";
import { LayoutResearcher } from "../../themes/userq/Layouts/layout_researcher";
import { OverviewTestDetail } from "../../themes/userq/TestResults/overview/OverviewTestDetail";
import { OverviewParticipant } from "../../themes/userq/TestResults/overview/OverviewParticipant";
import { OverviewEngagement } from "../../themes/userq/TestResults/overview/OverviewEngagement";
import { TestResultsSidebarNavigation } from "./components/test_results_sidebar_navigation";
import { useState, useEffect, useRef } from "react";
import { GetTestOverview } from "../../../services/test_result";
import toast from "react-hot-toast";
import moment from "moment";
import { useRecoilState } from "recoil";
import { testResultAtomFamily, testProjectAtomFamily } from "../../../store/testResultAtoms";
import { LoadingIcon } from "../../loader/loadingIcon";
import { TestResultsHeader } from "../../themes/userq/TestResultsHeader/TestResultsHeader";
import { PieStatsBox } from "./components/pie_stats_box";
import { Button } from "../../themes/userq/Button/Button";
import { Icon } from "../../themes/userq/Icon/Icon";
import { Text } from "../../themes/userq/Text/Text";
import TestSummaryModal from "../../dialog/test_summary_modal";
import { NoParticipants } from "./components/no_participants";
import { ParticipantsNotAvailable } from "./components/participants_not_available";
import { TreeTasksOverviewStatsBox } from "./components/tree_tasks_overview_stats_box";
import { LinearAxisChartStatsBox } from "./components/linear_axis_chart_stats_box";
import { renderTestTitle, roundNumber } from "../../../lib/helpers";
import { Box } from "../../themes/userq/Box/Box";
import { Helmet } from "react-helmet";
import { ToastMessage } from "../../themes/userq/ToastMessage/ToastMessage";
import { settings } from "../../../data/settings";

export default function TestResultOverview({ isSharedLink }) {
    let { test_id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const hasFetchedTestRef = useRef({});

    const [sectionLoading, setSectionLoading] = useState(false);
    const [testDetailData, setTestDetailData] = useState([]);

    const [testPrototypeData, setTestPrototypeData] = useState("");
    const [testFirstClickData, setFirstClickData] = useState("");

    const [parti, setParti] = useState({});

    const [treeTestOverview, setTreeTestOverview] = useState(null);

    const [testSummaryModal, setTestSummaryModal] = useState({
        open: false,
    });

    const [test, setTest] = useRecoilState(testResultAtomFamily(test_id));
    const [averageTimeSpend, setAverageTimeSpend] = useState("");
    const [areaClosedChartData, setAreaClosedChartData] = useState([]);
    const [show_support_panel, setShowSupportPanel] = useState(false);
    const [totalReportApprovedByAdmin, setTotalReportApprovedByAdmin] =
        useState(0);

    const [project, setProject] = useRecoilState(testProjectAtomFamily(test_id));

    const showError = (error) => {
        toast(
            <ToastMessage
                type={"error"}
                message={error}
                closable={false}
                onClose={() => {
                    toast.dismiss();
                }}
            />,
            {
                id: "error",
                className: "errortoast",
                position: "bottom-center",
                duration: settings.toast_duration,
            }
        );
    };

    const getOverview = () => {
        let token = ReactSession.get("token");

        let guest_result_token = "";
        if (location.pathname.substr(1, 1) === "v") {
            if (!ReactSession.get("guest_result_token")) {
                const randomToken = Math.random().toString(36).substr(2, 15);
                ReactSession.set("guest_result_token", randomToken);
            }

            guest_result_token = ReactSession.get("guest_result_token");
        }

        let admin_result_token = "";
        if (location.pathname.substr(1, 1) === "a") {
            if (!ReactSession.get("admin_result_token")) {
                const randomToken = Math.random().toString(36).substr(2, 15);
                ReactSession.set("admin_result_token", randomToken);
            }

            admin_result_token = ReactSession.get("admin_result_token");
        }

        setSectionLoading(true);
        GetTestOverview(
            test_id,
            token,
            guest_result_token,
            admin_result_token
        ).then((response) => {
            setSectionLoading(false);
            if (!response) {
                return;
            }

            if (response.success) {
                const responseData = response?.data || {};
                const testData = responseData?.test;
                const projectData = testData?.workspace_project;

                // check if team member is active
                if (responseData.workspace_project_team_member) {
                    if (responseData.workspace_project_team_member.status != 'active') {
                        navigate("/wsp/" + responseData.workspace_project_team_member.workspace_id + "/p/" + responseData.workspace_project_team_member.workspace_project_id + "/project-no-access")
                    }
                }

                // set project data
                if (projectData) {
                    setProject(projectData);
                }

                // check test is available for sharing
                if (location.pathname.substr(1, 1) === 'v' && responseData.is_share_result) {
                    navigate(`/v/results/${test_id}/results-not-available`);
                }

                // check if guest user not validate there password
                if (location.pathname.substr(1, 1) === "v" && testData?.password && !responseData.test_password_verify) {
                    return navigate(`/v/results/${test_id}/password`);
                }

                // set test data
                if (testData) {
                    setTest(testData);
                }

                setTotalReportApprovedByAdmin(responseData.totalReportApprovedByAdmin || 0);
                setParti(responseData.participants);
                setAreaClosedChartData(responseData.testResultoverviewChart);
                setTestDetailData(responseData.testDetailOverviewArray);
                setTestPrototypeData(responseData.prototype_test_summary);
                setFirstClickData(responseData.first_click_test_summary);

                if (testData?.methodology == "Tree Test") {
                    setTreeTestOverview(responseData.tree_test_summary);
                }

                if (testData?.total_time_spent) {
                    var averageTimeSpendMinute = Math.floor(
                        testData.total_time_spent / (testData.test_results_count * 60)
                    );
                    var averageTimeSpendSeconds = (
                        (testData.total_time_spent / testData.test_results_count) %
                        60
                    ).toFixed(0);
                    setAverageTimeSpend(
                        `${averageTimeSpendMinute}m ${averageTimeSpendSeconds}s`
                    );
                }
            } else if (response.message == "Project not found.") {
                navigate("/404");
            } else if (response.message == "Test Record Not found") {
                navigate("/404");
            } else {
                if (location.pathname.substr(1, 1) === "v") {
                    if (response.test_shared_results && !response.test_password_verify) {
                        return navigate(`/v/results/${test_id}/password`);
                    } else if (!response.test_shared_results) {
                        return navigate(`/v/results/${test_id}/results-not-available`);
                    }
                }
                if (location.pathname.substr(1, 1) === "a") {
                    if (!response.test_results_available) {
                        return navigate(`/v/results/${test_id}/results-not-available`);
                    }
                }
                showError(response.message);
            }
        });
    };

    useEffect(() => {
        const fetchKey = `${location.pathname}-${test_id}`;
        if (hasFetchedTestRef.current[fetchKey]) {
            return;
        }

        hasFetchedTestRef.current[fetchKey] = true;
        getOverview();
    }, [location.pathname, test_id]);

    const callbackTopbar = () => {
        getOverview();
    };
    
    const getTotalParticipants = () => {
        var total = 0;

        for (var key in parti.gender) {
            total += parti.gender[key];
        }
        return total > 0 ? true : false;
    };

    const averageTaskTime = (timeSpend, resultCount) => {
        var averageTimeSpendMinute = Math.floor(timeSpend / (resultCount * 60));
        var averageTimeSpendSeconds = ((timeSpend / resultCount) % 60).toFixed(0);

        if (averageTimeSpendSeconds.length === 1) {
            return averageTimeSpendMinute + "m 0" + averageTimeSpendSeconds + "s";
        } else {
            return averageTimeSpendMinute + "m " + averageTimeSpendSeconds + "s";
        }
    };

    return (
        <LayoutResearcher
            isSharedLink={isSharedLink}
            fixed_header_target={true}
            isLoading={false}
            wrapClass={"researcher-test-view-overflow create-test-data-wrapper"}
            resultHeaderClass={"result-header"}
            skipCheck={false}
            extendedFooter={false}
            activeMenu={""}
            openSupportPanel={show_support_panel}
            hideSupportPanel={() => {
                setShowSupportPanel(false);
            }}
        >
            <Helmet>
                <title>
                    Overview{" "}
                    {test && test.methodology
                        ? " - " + renderTestTitle(test.methodology)
                        : ""}{" "}
                    | UserQ
                </title>
            </Helmet>
            {test && (
                <div className="three-column-layout two-column-layout result">
                    <TestResultsHeader
                        project={project}
                        isSharedLink={isSharedLink}
                        test={test}
                        endedOn={
                            test.status === "completed"
                                ? moment.utc(test.ended_on).format("DD-MM-Y")
                                : ""
                        }
                        callbackTopbar={callbackTopbar}
                    />
                    <div className="three-column-layout-body">
                        <div className="three-column-layout-left">
                            <TestResultsSidebarNavigation
                                isSharedLink={isSharedLink}
                                methodology={
                                    test.methodology === "Five Seconds Test"
                                        ? "5 second test"
                                        : test.methodology
                                }
                                selected_index={0}
                                test_id={
                                    location.pathname.substr(1, 1) === "v" ? test_id : test.id
                                }
                                screening={
                                    test &&
                                        test.screening_questions &&
                                        test.screening_questions.length > 0
                                        ? "Yes"
                                        : "No"
                                }
                            />
                        </div>
                        <div className="two-column-right-side">
                            <div className="test-result-inner-data">
                                {sectionLoading && (
                                    <div
                                        className={
                                            "page-loader accountloading-box result-sections-loader"
                                        }
                                    >
                                        <LoadingIcon />
                                    </div>
                                )}
                                {!sectionLoading && (
                                    <div className="test-result-overview-data">
                                        <div
                                            className={
                                                "test-result-header-heading mb-20 d-flex justify-content-between align-items-center"
                                            }
                                        >
                                            <Text type={"h4"}>Overview</Text>

                                            <Button
                                                type={"ghost"}
                                                label={"View test summary"}
                                                cssclass={"purple-color text-decoration-underline"}
                                                onClick={() => {
                                                    setTestSummaryModal({
                                                        open: true,
                                                        test_id: test.id,
                                                    });
                                                }}
                                            />
                                        </div>

                                        <div className="test-result-overview-top-area mb-60 box-full-width">
                                            <div className="row">
                                                <div className="col-lg-3 col-md-6">
                                                    <OverviewParticipant
                                                        language={
                                                            test.language === "en" ? "english" : "arabic"
                                                        }
                                                        userQPanel={
                                                            test.target_group &&
                                                                (test.target_group.target_type ===
                                                                    "random-testers" ||
                                                                    (test.target_group.project_target_group &&
                                                                        test.target_group.target_type ===
                                                                        "target-group"))
                                                                ? test.test_results_tester_count
                                                                : 0
                                                        }
                                                        sharedLink={test.test_results_guest_count}
                                                        test={test}
                                                        totalReportApprovedByAdmin={
                                                            totalReportApprovedByAdmin
                                                        }
                                                    />
                                                </div>
                                                <div className="col-lg-3 col-md-6">
                                                    <OverviewTestDetail
                                                        items={testDetailData}
                                                        methodology={''}
                                                    />
                                                </div>

                                                <div className="col-lg-6">
                                                    <OverviewEngagement
                                                        liveFrom={moment
                                                            .utc(test.published_on)
                                                            .format("DD-MM-Y")}
                                                        avgTime={averageTimeSpend}
                                                        methodology={test.methodology}
                                                        graph={areaClosedChartData}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {test?.target_group?.target_type == "test-links" && (
                                            <>
                                                <div className="shared-link-overview-participants">
                                                    <Text type={"h4"}>Participants overview</Text>
                                                    <Box
                                                        size="large"
                                                        cssClasses="shared-link-overview-participants-box"
                                                    >
                                                        <ParticipantsNotAvailable small={true} />
                                                    </Box>
                                                </div>

                                                {test &&
                                                    test.methodology == "Tree Test" &&
                                                    treeTestOverview && (
                                                        <div className="result-pie-chart-wrap box-full-width mt-40">
                                                            <div className="mb-20 box-outer-heading">
                                                                <Text type={"h4"}>Test overview</Text>
                                                            </div>
                                                            <div className="tasksuccess-outerbox mb-40 d-block">
                                                                <div className="row">
                                                                    <div className="col-lg-6">
                                                                        <LinearAxisChartStatsBox
                                                                            title={"Task success %"}
                                                                            size={"medium"}
                                                                            percentage={(
                                                                                (treeTestOverview.overview
                                                                                    .success_count /
                                                                                    treeTestOverview.overview
                                                                                        .total_count) *
                                                                                100
                                                                            ).toFixed(2)}
                                                                        />
                                                                    </div>
                                                                    <div className="col-lg-6">
                                                                        <LinearAxisChartStatsBox
                                                                            title={"Task success directness  %"}
                                                                            size={"medium"}
                                                                            percentage={(
                                                                                (treeTestOverview.overview
                                                                                    .direct_count /
                                                                                    treeTestOverview.overview
                                                                                        .total_count) *
                                                                                100
                                                                            ).toFixed(2)}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row  mb-40">
                                                                <div className="col-md-12">
                                                                    <TreeTasksOverviewStatsBox
                                                                        isSharedLink={isSharedLink}
                                                                        tasks={treeTestOverview.tasks}
                                                                        title={"By Task"}
                                                                        hide={false}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="text-center d-flex justify-content-center">
                                                                <Button
                                                                    label={"Tree testing analysis"}
                                                                    size={"large"}
                                                                    iconRight={
                                                                        <Icon
                                                                            value={"forward-arrow"}
                                                                            colorClass={"gray-50-svg"}
                                                                            size={"medium"}
                                                                        />
                                                                    }
                                                                    onClick={() => {
                                                                        if (isSharedLink == "viewer") {
                                                                            navigate(
                                                                                "/v/results/" + test_id + "/tree-test"
                                                                            );
                                                                        } else if (isSharedLink == "admin") {
                                                                            navigate(
                                                                                "/a/results/" + test_id + "/tree-test"
                                                                            );
                                                                        } else {
                                                                            navigate(
                                                                                "/r/results/" + test.id + "/tree-test"
                                                                            );
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    )}
                                            </>
                                        )}

                                        {test?.target_group &&
                                            test.target_group.target_type !== "test-links" &&
                                            parti && (
                                                <>
                                                    {getTotalParticipants() ? (
                                                        <>
                                                            <div className="result-pie-chart-wrap box-full-width">
                                                                <div className="mb-20 box-outer-heading">
                                                                    <Text type={"h4"}>Participants overview</Text>
                                                                </div>
                                                                <div className="row  mb-40">
                                                                    <div className="col-lg-6">
                                                                        <PieStatsBox
                                                                            data={parti.age}
                                                                            title={"Age"}
                                                                        />
                                                                    </div>
                                                                    <div className="col-lg-6">
                                                                        <PieStatsBox
                                                                            data={parti.gender}
                                                                            title={"Gender"}
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div className="text-center d-flex justify-content-center">
                                                                    <Button
                                                                        label={"More about your participants"}
                                                                        size={"large"}
                                                                        iconRight={
                                                                            <Icon
                                                                                value={"forward-arrow"}
                                                                                colorClass={"gray-50-svg"}
                                                                                size={"medium"}
                                                                            />
                                                                        }
                                                                        onClick={() => {
                                                                            if (isSharedLink == "viewer") {
                                                                                navigate(
                                                                                    "/v/results/" +
                                                                                    test_id +
                                                                                    "/participants"
                                                                                );
                                                                            } else if (isSharedLink == "admin") {
                                                                                navigate(
                                                                                    "/a/results/" +
                                                                                    test_id +
                                                                                    "/participants"
                                                                                );
                                                                            } else {
                                                                                navigate(
                                                                                    "/r/results/" +
                                                                                    test.id +
                                                                                    "/participants"
                                                                                );
                                                                            }
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                            {test &&
                                                                test.methodology == "Tree Test" &&
                                                                treeTestOverview && (
                                                                    <div className="result-pie-chart-wrap box-full-width mt-40">
                                                                        <div className="mb-20 box-outer-heading">
                                                                            <Text type={"h4"}>Test overview</Text>
                                                                        </div>
                                                                        <div className="tasksuccess-outerbox mb-40 d-block">
                                                                            <div className="row">
                                                                                <div className="col-lg-6">
                                                                                    <LinearAxisChartStatsBox
                                                                                        title={"Task success %"}
                                                                                        size={"medium"}
                                                                                        percentage={(
                                                                                            (treeTestOverview.overview
                                                                                                .success_count /
                                                                                                treeTestOverview.overview
                                                                                                    .total_count) *
                                                                                            100
                                                                                        ).toFixed(2)}
                                                                                    />
                                                                                </div>
                                                                                <div className="col-lg-6">
                                                                                    <LinearAxisChartStatsBox
                                                                                        title={"Task success directness  %"}
                                                                                        size={"medium"}
                                                                                        percentage={(
                                                                                            (treeTestOverview.overview
                                                                                                .direct_count /
                                                                                                treeTestOverview.overview
                                                                                                    .total_count) *
                                                                                            100
                                                                                        ).toFixed(2)}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="row  mb-40">
                                                                            <div className="col-md-12">
                                                                                <TreeTasksOverviewStatsBox
                                                                                    tasks={treeTestOverview.tasks}
                                                                                    title={"By Task"}
                                                                                    hide={false}
                                                                                />
                                                                            </div>
                                                                        </div>

                                                                        <div className="text-center d-flex justify-content-center">
                                                                            <Button
                                                                                label={"Tree testing analysis"}
                                                                                size={"large"}
                                                                                iconRight={
                                                                                    <Icon
                                                                                        value={"forward-arrow"}
                                                                                        colorClass={"gray-50-svg"}
                                                                                        size={"medium"}
                                                                                    />
                                                                                }
                                                                                onClick={() => {
                                                                                    if (isSharedLink == "viewer") {
                                                                                        navigate(
                                                                                            "/v/results/" +
                                                                                            test_id +
                                                                                            "/tree-test"
                                                                                        );
                                                                                    } else if (isSharedLink == "admin") {
                                                                                        navigate(
                                                                                            "/a/results/" +
                                                                                            test_id +
                                                                                            "/tree-test"
                                                                                        );
                                                                                    } else {
                                                                                        navigate(
                                                                                            "/r/results/" +
                                                                                            test.id +
                                                                                            "/tree-test"
                                                                                        );
                                                                                    }
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                )}
                                                        </>
                                                    ) : (
                                                        <NoParticipants small={true} />
                                                    )}
                                                </>
                                            )}

                                        {testPrototypeData &&
                                            testPrototypeData.taskType === "closed" &&
                                            testPrototypeData.resultcount > 0 && (
                                                <div className="test-result-overview-prototype-data-area mb-60 box-full-width mt-60">
                                                    <div
                                                        className={
                                                            "test-result-overview-prototype-data-area-header"
                                                        }
                                                    >
                                                        <Text type={"h4"}>Test overview</Text>
                                                        <Text
                                                            type={"body-text-2"}
                                                            fontWeight={"medium-font"}
                                                            cssClasses="light-dark-text mt-20"
                                                        >
                                                            This is an overview to show how your testers
                                                            performed on the different tasks.
                                                        </Text>
                                                    </div>

                                                    <div className="prototype-overview-content mt-20 mb-40 prototype-result-overview-wrap p-0">
                                                        <div className="row">
                                                            <div className={`col-lg-3 col-md-6`}>
                                                                <div className=" prototype-overview-inner-data average-click">
                                                                    <Text
                                                                        type={"body-text-1"}
                                                                        fontWeight={"medium-font"}
                                                                        children={"Total tasks"}
                                                                    />

                                                                    <div className={`data-percent d-flex`}>
                                                                        <Icon size={"large"} value={"click"} />
                                                                        <Text
                                                                            type={"h3"}
                                                                            children={
                                                                                testPrototypeData.prototypeTaskCount
                                                                            }
                                                                        />
                                                                    </div>

                                                                    <Text
                                                                        type={"caption"}
                                                                        cssClasses={"gray-color"}
                                                                    >
                                                                        {testPrototypeData.prototypeTaskCount}{" "}
                                                                        {testPrototypeData.prototypeTaskCount === 1
                                                                            ? "task"
                                                                            : "tasks"}{" "}
                                                                        and{" "}
                                                                        {
                                                                            testPrototypeData.prototypeTaskQuestionCount
                                                                        }{" "}
                                                                        follow up questions
                                                                    </Text>
                                                                </div>
                                                            </div>

                                                            <div className={`col-lg-3 col-md-6`}>
                                                                <div className=" prototype-overview-inner-data completion-rate">
                                                                    <Text
                                                                        type={"body-text-1"}
                                                                        fontWeight={"medium-font"}
                                                                        children={"Completion rate"}
                                                                    />

                                                                    <div className={`data-percent d-flex`}>
                                                                        <Icon
                                                                            size={"large"}
                                                                            value={"success"}
                                                                            colorClass={"success-green-200-svg"}
                                                                        />
                                                                        <Text
                                                                            type={"h3"}
                                                                            cssClasses={"green-text"}
                                                                            children={`${roundNumber(
                                                                                testPrototypeData.successTaskCountPercentage,
                                                                                1
                                                                            )}%`}
                                                                        />
                                                                    </div>

                                                                    <Text
                                                                        type={"caption"}
                                                                        cssClasses={"gray-color"}
                                                                    >
                                                                        An average of{" "}
                                                                        {roundNumber(
                                                                            testPrototypeData.successTaskCount,
                                                                            0
                                                                        )}{" "}
                                                                        users per task have completed the task on
                                                                        the goal screen
                                                                    </Text>
                                                                </div>
                                                            </div>

                                                            <div className={`col-lg-3 col-md-6`}>
                                                                <div className=" prototype-overview-inner-data skip-rate">
                                                                    <Text
                                                                        type={"body-text-1"}
                                                                        fontWeight={"medium-font"}
                                                                        children={"Skip rate"}
                                                                    />

                                                                    <div className={`data-percent d-flex`}>
                                                                        <Icon
                                                                            size={"large"}
                                                                            value={"forward"}
                                                                            colorClass={"gray-700-svg"}
                                                                        />
                                                                        <Text
                                                                            type={"h3"}
                                                                            cssClasses={"light-dark-text"}
                                                                            children={`${roundNumber(
                                                                                testPrototypeData.skipTaskCountPercentage,
                                                                                1
                                                                            )}%`}
                                                                        />
                                                                    </div>

                                                                    <Text
                                                                        type={"caption"}
                                                                        cssClasses={"gray-color"}
                                                                    >
                                                                        {testPrototypeData.skipTaskCount} out of{" "}
                                                                        {testPrototypeData.resultcount} have left or
                                                                        given up on your task
                                                                    </Text>
                                                                </div>
                                                            </div>

                                                            <div className={`col-lg-3 col-md-6`}>
                                                                <div className=" prototype-overview-inner-data average-time">
                                                                    <Text
                                                                        type={"body-text-1"}
                                                                        fontWeight={"medium-font"}
                                                                        children={"Average time spent"}
                                                                    />

                                                                    <div className={`data-percent d-flex`}>
                                                                        <Icon size={"large"} value={"time"} />
                                                                        <Text
                                                                            type={"h3"}
                                                                            children={`${averageTaskTime(
                                                                                testPrototypeData.prototypeTaskResultsAverageTime,
                                                                                testPrototypeData.resultcount
                                                                            )}`}
                                                                        />
                                                                    </div>

                                                                    <Text
                                                                        type={"caption"}
                                                                        cssClasses={"gray-color"}
                                                                    >
                                                                        The average time spent on this task is{" "}
                                                                        {averageTaskTime(
                                                                            testPrototypeData.prototypeTaskResultsAverageTime,
                                                                            testPrototypeData.resultcount
                                                                        )}
                                                                    </Text>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="text-center d-flex justify-content-center test-result-overview-prototype-data-area-footer">
                                                        <Button
                                                            label={"Task flow analysis"}
                                                            size={"large"}
                                                            iconRight={
                                                                <Icon
                                                                    value={"forward-arrow"}
                                                                    colorClass={"gray-50-svg"}
                                                                    size={"medium"}
                                                                />
                                                            }
                                                            onClick={() => {
                                                                if (isSharedLink == "viewer") {
                                                                    navigate(
                                                                        "/v/results/" + test_id + "/prototype-test"
                                                                    );
                                                                } else if (isSharedLink == "admin") {
                                                                    navigate(
                                                                        "/a/results/" + test_id + "/prototype-test"
                                                                    );
                                                                } else {
                                                                    navigate(
                                                                        "/r/results/" + test.id + "/prototype-test"
                                                                    );
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            )}

                                        {testFirstClickData && testFirstClickData.resultcount > 0 && (
                                            <div className="test-result-overview-prototype-data-area mb-60 first-click-overview box-full-width mt-60">
                                                <div
                                                    className={
                                                        "test-result-overview-prototype-data-area-header"
                                                    }
                                                >
                                                    <Text type={"h4"}>Test overview</Text>
                                                </div>

                                                <div className="prototype-overview-content mt-20 mb-40 prototype-result-overview-wrap p-0">
                                                    <div className="row">
                                                        <div className={`col-lg-4 col-md-6`}>
                                                            <div className=" prototype-overview-inner-data average-time">
                                                                <Text
                                                                    type={"h4"}
                                                                    children={"Average time spent"}
                                                                />

                                                                <div className={`data-percent d-flex`}>
                                                                    <Icon size={"large"} value={"time"} />
                                                                    <Text
                                                                        type={"h1"}
                                                                        children={`${averageTaskTime(
                                                                            testFirstClickData.averageTime,
                                                                            testFirstClickData.resultcount
                                                                        )}`}
                                                                    />
                                                                </div>

                                                                <Text type={"caption"}>
                                                                    The average time spent on this task is{" "}
                                                                    {averageTaskTime(
                                                                        testFirstClickData.averageTime,
                                                                        testFirstClickData.resultcount
                                                                    )}
                                                                </Text>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="text-center d-flex justify-content-center test-result-overview-prototype-data-area-footer">
                                                    <Button
                                                        label={"First click analysis"}
                                                        size={"large"}
                                                        iconRight={
                                                            <Icon
                                                                value={"forward-arrow"}
                                                                colorClass={"gray-50-svg"}
                                                                size={"medium"}
                                                            />
                                                        }
                                                        onClick={() => {
                                                            if (isSharedLink == "viewer") {
                                                                navigate(
                                                                    "/v/results/" + test_id + "/first-click"
                                                                );
                                                            } else if (isSharedLink == "admin") {
                                                                navigate(
                                                                    "/a/results/" + test_id + "/prototype-test"
                                                                );
                                                            } else {
                                                                navigate(
                                                                    "/r/results/" + test.id + "/first-click"
                                                                );
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <TestSummaryModal
                test_id={testSummaryModal.test_id}
                openModal={testSummaryModal.open}
                close={() => {
                    setTestSummaryModal({ ...testSummaryModal, open: false });
                }}
            />
            {!isSharedLink && (
                <a
                    onClick={(e) => {
                        e.preventDefault();

                        setShowSupportPanel(true);
                    }}
                    href={process.env.REACT_APP_URL + "r/support"}
                    target="_blank"
                    className="support-button"
                >
                    <Icon value={"support"} colorClass={"gray-50-svg"} size={"medium"} />
                    Support
                </a>
            )}
        </LayoutResearcher>
    );
}
